import { type FC } from "react";
import { Table, TableRow, TableDataCell } from "../../../table";

interface ServiceIdSummaryProps {
  inquiryId: string;
  serviceId: string;
  onSelectServiceId?: (inquiryId: string) => void;
}

export const ServiceIdSummary: FC<ServiceIdSummaryProps> = ({ inquiryId, serviceId, onSelectServiceId }) => {
  return (
    <div className="card card-body shaded pb-3 mb-4" style={{ marginTop: "-15px" }}>
      <Table className="table-transparent mb-0" tableHover={false} tableHasIcons={false}>
        <tbody>
          <TableRow>
            <th className="p-0">Service ID</th>
            <TableDataCell className="fw-bold p-0 fs-6 bg-transparent" textAlign="right">
              {onSelectServiceId ? (
                <a
                  href={`/inquiry/${inquiryId}`}
                  onClick={event => {
                    event.preventDefault();
                    onSelectServiceId(inquiryId);
                  }}
                >
                  {serviceId}
                </a>
              ) : (
                serviceId
              )}
            </TableDataCell>
          </TableRow>
        </tbody>
      </Table>
    </div>
  );
};
